import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68f570da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: { width: '100%', fontSize: '0.8rem' } }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center",
  width: "30"
}, "TT", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center",
  width: "60"
}, "Mã VT", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center break-word",
  width: "200"
}, "Tên vật tư", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center",
  width: "120"
}, "Đặc tính", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center break-word",
  width: "50"
}, "Đơn vị tính", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  width: "100"
}, "Số lượng", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  width: "70"
}, "Đơn giá", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "text-center",
  width: "100"
}, "Thành tiền", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "A"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "B"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "C"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "D"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "E"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "1"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "2"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "3 = 1 * 2"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "4"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "5"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "6 = 4 * 5"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "7 = 1 - 4"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "8 = 2"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "9 = 7 * 8")
], -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "14",
  class: "text-center fst-italic"
}, "Không có dữ liệu", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end fw-bolder" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = { class: "text-end fw-bolder" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = { class: "text-end fw-bolder" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bolder text-center",
  colspan: "5"
}, "Cộng", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bolder text-end" }, "-", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bolder text-end" }, "-", -1))
const _hoisted_28 = { class: "fw-bolder text-end" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bolder text-end" }, "-", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bolder text-end" }, "-", -1))
const _hoisted_31 = { class: "fw-bolder text-end" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bolder text-end" }, "-", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "fw-bolder text-end" }, "-", -1))
const _hoisted_34 = { class: "fw-bolder text-end" }

import { computed, PropType } from 'vue';
import { ITheoDoiThucHienHopDongResponseBase } from "@/core/interfaces/ApiResponses";
import { formatCurrencyAndQuantity } from "@/core/helpers/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheoDoiHopDongTable',
  props: {
  items: {
    type: Array as PropType<ITheoDoiThucHienHopDongResponseBase[]>,
    required: true,
  }
},
  setup(__props) {

const headers = ['Theo Hợp đồng', 'Thực hiện', 'Chênh lệch'];

const props = __props;

const totalThanhTien = computed(() => {
  let result = {
    hop_dong: 0,
    thuc_hien: 0,
    chenh_lech: 0,
  };

  props.items?.forEach(({ thanh_tien_hop_dong, thanh_tien_nhap_kho, thanh_tien_chenh_lech }) => {
    result.hop_dong += thanh_tien_hop_dong ? +thanh_tien_hop_dong : 0;

    result.thuc_hien += thanh_tien_nhap_kho ? +thanh_tien_nhap_kho : 0;

    result.chenh_lech += thanh_tien_chenh_lech ? +thanh_tien_chenh_lech : 0;
  })

  return {
    hop_dong: formatCurrencyAndQuantity(Math.round(result.hop_dong), false),
    thuc_hien: formatCurrencyAndQuantity(Math.round(result.thuc_hien), false),
    chenh_lech: formatCurrencyAndQuantity(Math.round(result.chenh_lech), false),
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (header, index) => {
        return _createElementVNode("th", {
          key: index,
          class: "text-center",
          colspan: "3",
          width: "270"
        }, _toDisplayString(header), 1)
      }), 64))
    ]),
    _createElementVNode("tr", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.length, (n) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: n }, [
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ], 64))
      }), 128))
    ]),
    _hoisted_10,
    (!__props.items.length)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_11, _hoisted_13))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_14, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, _toDisplayString(item.ma_vat_tu), 1),
              _createElementVNode("td", null, _toDisplayString(item.ten_vat_tu), 1),
              _hoisted_15,
              _createElementVNode("td", null, _toDisplayString(item.don_vi_tinh), 1),
              _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formatCurrencyAndQuantity)(+item.so_luong_hop_dong )), 1),
              _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatCurrencyAndQuantity)(+item.don_gia_hop_dong)), 1),
              _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatCurrencyAndQuantity)(item.thanh_tien_hop_dong, false)), 1),
              _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatCurrencyAndQuantity)(item.so_luong_nhap_kho)), 1),
              _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(formatCurrencyAndQuantity)(item.don_gia_nhap_kho)), 1),
              _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(formatCurrencyAndQuantity)(item.thanh_tien_nhap_kho, false)), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(formatCurrencyAndQuantity)(item.so_luong_chenh_lech)), 1),
              _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatCurrencyAndQuantity)(item.don_gia_hop_dong)), 1),
              _createElementVNode("td", _hoisted_24, _toDisplayString(_unref(formatCurrencyAndQuantity)(item.thanh_tien_chenh_lech, false)), 1)
            ]))
          }), 128)),
          _createElementVNode("tr", null, [
            _hoisted_25,
            _hoisted_26,
            _hoisted_27,
            _createElementVNode("td", _hoisted_28, _toDisplayString(totalThanhTien.value.hop_dong), 1),
            _hoisted_29,
            _hoisted_30,
            _createElementVNode("td", _hoisted_31, _toDisplayString(totalThanhTien.value.thuc_hien), 1),
            _hoisted_32,
            _hoisted_33,
            _createElementVNode("td", _hoisted_34, _toDisplayString(totalThanhTien.value.chenh_lech), 1)
          ])
        ], 64))
  ]))
}
}

})